





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class ECCommodityView extends Vue {
  public items: Common.ECCommodity[] = new Array();
  public params: Common.ECCommodityMasterQuery = new Common.ECCommodityMasterQuery();
  public importQuery = new Common.ImportQuery('EC連携商品', 'ECCommodity');
  public exportQuery = new Common.ExportQuery('EC連携商品', this.params);
  public sortOptions: any = [
    { value: 'ecFlag', text: 'EC連携先' },
    { value: 'ecCommodityCode', text: '連携先商品コード' },
    { value: 'commodity', text: '商品' },
  ];
}
